module.exports = __webpack_public_path__ + "static/media/room-8.de60ab6c.jpeg";